import axiosService from '../../services/axiosService';
import { API_ACCOUNT_ENDPOINT } from '@app/constants/api';
import scConfig from '@app/config';

const BASE_URL = `${API_ACCOUNT_ENDPOINT}/v1`;
const LIST_URL = {
    LOGIN: `${BASE_URL}/ScServiceLogin`,
    PING: `${BASE_URL}/PingPing`,
};
export const login = (model) => {
    if (!scConfig.IS_PROD_ENV) {
        model = { ...model, isDevCookie: false };
    }
    return axiosService.securePost(LIST_URL.LOGIN, model);
};

export const doPingPong = () => axiosService.get(LIST_URL.PING);
